<template>
  <div class="tabel__lgota__wrapper">
    <h3>Денежные средства из ГОС бюджета</h3>
    <div class="tabel__form">
      <form @submit.prevent="func_get_data">
        <div class="form__group">
          <label>Школа</label>
          <v-select
            label="school"
            v-model="school_value"
            :options="school_list"
          />
        </div>
        <div class="form__group">
          <label>Дата</label>
          <div class="date__flex">
            <input type="date" required v-model="dateStart" />
            <span>-</span>
            <input type="date" required v-model="dateEnd" />
          </div>
        </div>

        <button class="btn">Сформировать отчет</button>
      </form>
    </div>
    <div v-if="loader">Загрузка, подождите...</div>
    <div class="tabel__table" v-if="result_list">
      <p v-if="school_value && dateStart && dateEnd">
        {{ school_value?.school }}
        <span>{{
          new Date(dateStart).toLocaleDateString() +
          ' - ' +
          new Date(dateEnd).toLocaleDateString()
        }}</span>
      </p>
      <table border="1" class="table-parent_money">
        <tr>
          <th colspan="7" class="color-yellow">
            Денежные средства из ГОС бюджета
          </th>
        </tr>
        <tr>
          <th class="color-1">Бесплатные завтраки</th>
          <th class="color-1">Бесплатные обеды</th>
          <th class="color-1">Бесплатные полдники</th>
          <th class="">Льготные завтрак</th>
          <th class="">Льготные обед</th>
          <th class="">Льготные полдники</th>
          <th class="color-3">Льготные обеды ГПД</th>
        </tr>
        <tr>
          <td class="color-1">
            {{
              Number(
                result_list.find(x => x.spr_type_cash_id == 38)?.summ || 0,
              ).toFixed(2)
            }}
          </td>
          <td class="color-1">
            {{
              Number(
                result_list.find(x => x.spr_type_cash_id == 40)?.summ || 0,
              ).toFixed(2)
            }}
          </td>
          <td class="color-1">
            {{
              Number(
                result_list.find(x => x.spr_type_cash_id == 43)?.summ || 0,
              ).toFixed(2)
            }}
          </td>
          <td class="">
            {{
              Number(
                result_list.find(x => x.spr_type_cash_id == 18)?.summ || 0,
              ).toFixed(2)
            }}
          </td>
          <td class="">
            {{
              Number(
                result_list.find(x => x.spr_type_cash_id == 21)?.summ || 0,
              ).toFixed(2)
            }}
          </td>
          <td class="">
            {{
              Number(
                result_list.find(x => x.spr_type_cash_id == 23)?.summ || 0,
              ).toFixed(2)
            }}
          </td>
          <td class="color-3">
            {{
              Number(
                result_list.find(x => x.spr_type_cash_id == 27)?.summ || 0,
              ).toFixed(2)
            }}
          </td>
        </tr>
        <tr>
          <td colspan="7" class="color-yellow">
            Итого:
            {{
              Number(
                result_list.reduce((acc, val) => {
                  return acc + (val.summ ? Number(val.summ) : 0);
                }, 0),
              ).toFixed(2)
            }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      result_list: null,
      school_list: [],
      rows: [],
      school_value: null,
      dateStart: '',
      dateEnd: '',
      loader: false,
    };
  },
  methods: {
    func_get_school_list() {
      window.sendRequestAuth('/get_school_list', {}).then(result => {
        if (!result) return;
        this.school_list = result;
      });
    },
    func_get_data() {
      this.result_list = null;
      if (this.loader) return;
      this.loader = true;
      if (!this.school_value) {
        window.soundClick();
        this.$notify({
          group: 'foo',
          title: 'Ошибка',
          text: 'Заполните поля',
          type: 'error',
        });
        return;
      }
      window
        .sendRequestAuth('/get_gos_money', {
          school_id: this.school_value.school_id,
          date_start: this.dateStart,
          date_end: this.dateEnd,
        })
        .then(result => {
          if (!result) return;
          this.result_list = result;
          this.loader = false;
        });
    },
  },
  mounted() {
    this.func_get_school_list();
  },
};
</script>

<style>
.date__flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.date__flex input {
  flex-basis: 48%;
  width: 100%;
  display: block;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  outline: none;
}

.table-parent_money {
  font-size: 16px;
}

.table-parent_money th {
  padding: 10px;
  width: 30px;
}

.table-parent_money .color-blue {
  background: #43b8ff;
}

.table-parent_money .color-yellow {
  background: #eaf1bf;
}

.table-parent_money .color-1 {
  background: #d0aae9;
}

.table-parent_money .color-2 {
  background: #f59898;
}

.table-parent_money .color-3 {
  background: #df7aff;
}

.table-parent_money .color-4 {
  background: #b8c8f7;
}

.table-parent_money .color-5 {
  background: #fffdb4;
}

.table-parent_money .color-6 {
  background: #dcffdc;
}

.table-parent_money th,
.table-parent_money td {
  text-align: center;
}

.table-parent_money td {
  font-size: 16px;
  padding: 10px;
}
</style>
